import type { BannerSubJob } from '../components/creator/AnalysisProgressBanner';
import type { ScrapeProgressResponse } from './youtubeService';

export async function startChannelChecks(requests: {platform:string; promise:Promise<{job_id:string}>}[]): Promise<BannerSubJob[]> {
  const results = await Promise.allSettled(requests.map(request => request.promise));
  return results.map((result,index) => result.status === 'fulfilled'
    ? {platform:requests[index].platform, job_id:result.value.job_id, status:'pending', is_complete:false}
    : {platform:requests[index].platform, job_id:`failed-${requests[index].platform}`, status:'error', is_complete:true,
        error_user_message:result.reason instanceof Error ? result.reason.message : 'Could not start this platform check.'});
}

export async function updateChannelChecks(
  jobs: BannerSubJob[],
  readers: Record<string,(jobId:string) => Promise<ScrapeProgressResponse>>,
): Promise<BannerSubJob[]> {
  return Promise.all(jobs.map(async job => {
    if (job.is_complete) return job;
    try {
      const result = await readers[job.platform](job.job_id);
      return {...job, ...result, job_id:job.job_id, platform:job.platform};
    } catch {
      return {...job, is_complete:true, status:'error', error_user_message:
        `Could not confirm the ${job.platform} check. It may still be running. Your saved results are still available; this is not a confirmed completion.`};
    }
  }));
}
